import { zIndexValues } from 'utils/styles';

const useStyles = {
  paper: {
    marginTop: (theme) => theme.spacing(3),
    marginBottom: (theme) => theme.spacing(3),
    padding: (theme) => theme.spacing(20),
    [`${(theme) => theme.breakpoints.up(600 + theme.spacing(3) * 2)}`]: {
      marginTop: (theme) => theme.spacing(6),
      marginBottom: (theme) => theme.spacing(6),
      padding: (theme) => theme.spacing(3),
    },
  },
  stepper: {
    padding: (theme) => theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: (theme) => theme.spacing(3),
    marginLeft: (theme) => theme.spacing(1),
  },
  formControl: {
    margin: (theme) => theme.spacing(1),
    minWidth: 240,
  },

  modalModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'scroll',
    zIndex: zIndexValues.modal4 + 1,
  },

  modalPaper: {
    backgroundColor: '#FFFFF3',
    border: '2px solid #000',
    position: 'absolute',
    width: 800,
    boxShadow: (theme) => theme.shadows[5],
    padding: (theme) => theme.spacing(2, 4, 3),
  },

  modalPaperNarrow: {
    backgroundColor: '#FFFFF3',
    border: '2px solid #000',
    position: 'absolute',
    width: 500,
    boxShadow: (theme) => theme.shadows[5],
    padding: (theme) => theme.spacing(2, 4, 3),
  },

  modalPaperWide: {
    backgroundColor: '#FFFFF3',
    border: '2px solid #000',
    position: 'absolute',
    width: 800,
    height: 500,
    boxShadow: (theme) => theme.shadows[5],
    padding: (theme) => theme.spacing(2, 4, 3),
  },

  description: {
    backgroundColor: '#fafafa',
    height: 185,
  },
};

export default useStyles;
